export default __webpack_public_path__ + "static/media/dropdown.fef18eeb.svg";